import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import "./disclaimer.scss";

const messages = defineMessages({
  disclaimerText: {
    id: "disclaimerText",
    defaultMessage: "Some answers by Natera Results Assistant are AI-generated",
  },
});

const Disclaimer: FC = () => {
  const intl = useIntl();

  return (
    <div className="disclaimer-container">
      {intl.formatMessage(messages.disclaimerText)}
    </div>
  );
};

export default Disclaimer;
